import { formatarTelefone } from '@/lib/telefone';

/**
 * Nome que a tela mostra para o contato de uma conversa.
 *
 * Precedência: **nome salvo pela clínica → pushName do WhatsApp → telefone**.
 *
 * O `contatoNome` vem do `pushName` (repositorio.js), que é o nome que a PESSOA
 * escolheu no aparelho dela — às vezes o nome de uma empresa, às vezes um
 * apelido, às vezes o nome da própria clínica. Por isso a clínica pode salvar o
 * seu próprio nome para aquele contato, e ele ganha do que veio do WhatsApp.
 *
 * Fica numa função só porque a regra precisa valer em TODO lugar que mostra o
 * nome — lista, cabeçalho da conversa, painel, diálogo de transferência. Três
 * cópias da mesma precedência viram três comportamentos diferentes no dia em
 * que uma delas for esquecida.
 *
 * Nunca devolve vazio: sem nome nenhum, o telefone formatado identifica a
 * conversa. Um item de lista em branco é impossível de escolher.
 */
export function nomeDoContato(conversa) {
  const salvo = String(conversa?.contatoNomeSalvo ?? '').trim();
  if (salvo) return salvo;

  const doWhatsapp = String(conversa?.contatoNome ?? '').trim();
  if (doWhatsapp) return doWhatsapp;

  return formatarTelefone(conversa?.contatoTelefone) || 'Contato sem nome';
}

/** A clínica renomeou este contato? Usado para explicar a origem do nome. */
export const temNomeSalvo = (conversa) =>
  Boolean(String(conversa?.contatoNomeSalvo ?? '').trim());

/**
 * ★ VN — editar o nome no CHAT espelha no cadastro do lead?
 *
 * Só quando a conversa tem `leadId` E quem edita tem permissão de vendas
 * (gestor/sdr): as rules exigem `podeVendas` para escrever em `leads`, e o
 * `renomearLead` é um lote tudo-ou-nada — a recepcionista gravando o lead
 * derrubaria até o rename da própria conversa. Hoje conversa de recepção não
 * tem `leadId` (medido: 0), mas a regra fica escrita para o dia em que tiver.
 */
export const PAPEIS_QUE_ESPELHAM = ['gestor', 'sdr'];
export const espelhaNoLead = (conversa, papel) =>
  Boolean(conversa?.leadId) && PAPEIS_QUE_ESPELHAM.includes(papel);

/** Texto ESTÁTICO do editor de nome no chat — diz o que aquele Salvar faz, antes de salvar. */
export function ajudaDoNomeNoChat(conversa, papel) {
  if (espelhaNoLead(conversa, papel)) {
    return 'Muda também no cadastro do lead e nas outras conversas dele. Vazio volta a mostrar o nome do WhatsApp (só nesta conversa).';
  }
  if (conversa?.leadId) {
    return 'Só nesta conversa — o nome do cadastro só muda pela equipe de vendas. Vazio volta a mostrar o nome do WhatsApp.';
  }
  return 'Vazio volta a mostrar o nome do WhatsApp.';
}
